module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/_react-modal@1.9.7@react-modal/lib/index.js
// module id = 1796
// module chunks = 0